var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3000,
    height: 1583,
    viewBox: "0 0 3000 1583",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1794_3596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1941 407C3161.12 407 4142 1260.98 4142 2305C4142 3349.02 3161.12 4203 1941 4203C720.882 4203 -260 3349.02 -260 2305C-260 1260.98 720.882 407 1941 407Z",
    fill: "url(#paint0_linear_1794_3596)",
    stroke: "#7EA0CF",
    strokeWidth: 64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1941 405C3157.3 405 4141 1256.85 4141 2305C4141 3353.15 3157.3 4205 1941 4205C724.696 4205 -259 3353.15 -259 2305C-259 1256.85 724.696 405 1941 405Z",
    stroke: "#F9FAFD",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1941 415C3149.97 415 4129 1261.71 4129 2305C4129 3348.29 3149.97 4195 1941 4195C732.032 4195 -247 3348.29 -247 2305C-247 1261.71 732.032 415 1941 415Z",
    stroke: "#ADC3E2",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.87,
    filter: "url(#filter1_f_1794_3596)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1861,
    cy: 1733.5,
    rx: 1620,
    ry: 1233.5,
    fill: "#333466"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.87,
    filter: "url(#filter2_f_1794_3596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3940 1904C3940 2612.03 3213.36 3186 2317 3186C1420.64 3186 694 2612.03 694 1904C694 1195.97 1420.64 622 2317 622C3213.36 622 3940 1195.97 3940 1904Z",
    fill: "#201A4D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1794_3596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2044.47 975.507C2024.17 1021.16 1888.96 1056.17 1803.11 1072C1788.11 1074.77 1778.45 1089.67 1782.44 1104.39C1785 1113.85 1792.73 1121.01 1802.35 1122.85L1826.55 1127.47C1835.71 1129.22 1842.34 1137.23 1842.34 1146.57C1842.34 1155.55 1836.19 1163.37 1827.45 1165.47L1794.65 1173.36C1781.86 1176.43 1768.42 1175.38 1756.27 1170.35L1719.99 1155.32C1709.76 1151.08 1698.29 1150.95 1687.97 1154.96C1676.6 1159.37 1667.64 1168.39 1663.31 1179.79L1653.62 1205.32C1650.97 1212.31 1652.17 1220.17 1656.8 1226.04C1664.13 1235.33 1662.46 1248.82 1653.1 1256.05L1649.47 1258.85C1644.19 1262.93 1637.53 1264.8 1630.9 1264.08L1611.62 1261.98C1598.92 1260.6 1586.89 1267.94 1582.31 1279.87L1581.53 1281.9C1578.09 1290.87 1580.16 1301.02 1586.84 1307.93C1596.8 1318.23 1595.94 1334.82 1584.96 1344.04L1539.29 1382.35C1535 1385.95 1531.11 1390 1527.59 1394.37C1518.56 1405.57 1506.12 1420.18 1503.45 1420.18C1502.59 1420.18 1503.02 1423.34 1504.25 1428.41C1512.96 1464.29 1548.79 1486.15 1585.61 1483.42L1588.49 1483.21C1599.52 1482.39 1610.58 1484.21 1620.77 1488.52C1634.09 1494.14 1648.82 1495.49 1662.93 1492.38L1695.46 1485.2C1704.96 1483.11 1714.9 1484.27 1723.66 1488.5L1731.24 1492.15C1750.7 1501.54 1757.55 1525.85 1745.85 1544.02C1730.43 1567.96 1747.61 1599.47 1776.08 1599.47H1859.83C1880.9 1599.47 1895.18 1578.02 1887.05 1558.59C1883.18 1549.34 1884.27 1538.77 1889.94 1530.51L1898.56 1517.96C1902.26 1512.57 1905.01 1506.6 1906.7 1500.3L1924.23 1434.8C1928.67 1418.24 1937.28 1403.1 1949.25 1390.83L1969.62 1369.94C1983.39 1355.83 2001.15 1346.29 2020.52 1342.6C2048.83 1337.21 2073.23 1319.42 2087.02 1294.12L2106.89 1257.67C2117.64 1237.95 2134.73 1222.42 2155.38 1213.59L2165.92 1209.08C2185.74 1200.61 2208.15 1200.6 2227.98 1209.06C2232.61 1211.03 2237.04 1213.44 2241.2 1216.26L2256.35 1226.49C2266.97 1233.66 2278.86 1238.73 2291.38 1241.41L2320.07 1247.56C2335.23 1250.8 2351.01 1249.36 2365.33 1243.43L2432.26 1215.69C2437.04 1213.71 2442.5 1216.2 2444.14 1221.12C2445.36 1224.76 2448.77 1227.22 2452.61 1227.22H2457.84C2466.79 1227.22 2474.04 1234.47 2474.04 1243.41V1248.42C2474.04 1251.14 2474.56 1253.84 2475.58 1256.37L2493.58 1300.84C2498.41 1312.76 2500.88 1325.5 2500.88 1338.35V1355.27C2500.88 1376.05 2509.27 1395.95 2524.14 1410.47C2536.94 1422.97 2553.69 1430.63 2571.52 1432.14L2612.35 1435.59C2630.24 1437.11 2648.19 1433.73 2664.46 1426.13C2684.81 1416.64 2706.57 1406.96 2709.08 1407.52C2711.14 1407.98 2713.07 1399.68 2714.58 1389.93C2716.77 1375.83 2712.77 1361.58 2704.69 1349.82L2703.1 1347.5C2697.1 1338.76 2693.89 1328.41 2693.89 1317.8V1297.84C2693.89 1283.94 2703.86 1272.05 2717.55 1269.62C2727.67 1267.83 2737.97 1271.59 2744.55 1279.47L2775.02 1315.96C2779.88 1321.78 2782.54 1329.12 2782.54 1336.69V1339.18C2782.54 1345.05 2784.57 1350.74 2788.3 1355.28C2794.65 1363.03 2795.86 1373.78 2791.38 1382.74L2788.85 1387.8C2784.81 1395.88 2784.14 1405.25 2787 1413.83L2794.3 1435.7C2797.25 1444.55 2801.56 1452.88 2807.07 1460.39L2816.41 1473.12C2819.49 1477.33 2822.26 1481.75 2824.54 1486.44C2830.12 1497.86 2837.25 1513.85 2837.25 1519.45C2837.25 1528.06 2849.91 1538.19 2853.46 1542.74C2857 1547.3 2862.07 1558.95 2863.08 1563.51C2868.21 1586.57 2890.03 1602 2913.66 1602H2932.81C2975.99 1602 3011 1566.99 3011 1523.81V750.532C3011 717.623 2994.81 686.821 2967.7 668.161L2959.17 662.291C2952.55 657.73 2945.4 653.984 2937.87 651.137L2829.49 610.115C2814.94 604.607 2799.3 602.571 2783.82 604.168L2750.48 607.609C2736.22 609.081 2722.44 613.601 2710.09 620.863L2700.58 626.447C2681.74 637.52 2659.2 640.457 2638.15 634.583C2631.1 632.617 2623.82 631.652 2616.51 631.496C2600.1 631.145 2578.55 629.978 2574.34 627.062C2570.74 624.573 2553.25 626.19 2537.14 628.433C2524.34 630.216 2513.19 637.872 2506.33 648.835C2501.78 656.12 2499.37 664.537 2499.37 673.128V675.657C2499.37 689.957 2493.76 703.688 2483.75 713.902L2481.76 715.934C2477.31 720.473 2472.19 724.297 2466.57 727.269L2464.6 728.314C2460.1 730.698 2455.84 733.53 2451.91 736.766L2407.26 773.455C2401.19 778.444 2396.27 784.682 2392.82 791.744C2389.59 798.374 2385.05 804.281 2379.47 809.112L2372.72 814.959L2356.62 827.451C2348.01 834.127 2337.43 837.75 2326.54 837.75C2317.65 837.75 2308.92 835.333 2301.29 830.759L2291.79 825.059C2290.7 824.404 2289.67 823.662 2288.7 822.838L2279.2 814.765C2274.15 810.476 2273.76 802.82 2278.34 798.038C2280.39 795.897 2281.54 793.044 2281.54 790.078V778.112C2281.54 771.702 2280.05 765.38 2277.18 759.647L2273.84 752.966C2266.99 739.27 2264.63 723.766 2267.08 708.651L2268.13 702.228C2269.29 695.054 2271.72 688.142 2275.28 681.811C2284.66 665.166 2301.22 653.797 2320.12 651.018L2324.6 650.359L2341.1 645.983C2346.38 644.583 2350.78 640.934 2353.13 636.003C2357.11 627.667 2354.38 617.673 2346.71 612.519L2335.86 605.226C2332.44 602.921 2328.61 601.265 2324.59 600.339L2263.8 586.373C2254.07 584.137 2244.06 583.371 2234.1 584.102L2185.99 587.629C2177.45 588.254 2169.04 589.973 2160.94 592.742L2089.98 617.011C2081.29 619.984 2073.05 624.139 2065.5 629.361L2010.41 667.428C2008.8 668.538 2007.34 669.837 2006.04 671.297L1991.57 687.627C1989.78 689.638 1990.13 692.748 1992.31 694.321C1994.8 696.123 1994.82 699.834 1992.34 701.659L1957.16 727.552C1953.27 730.422 1948.83 732.484 1944.13 733.62L1911.36 741.528C1898.9 744.535 1887.13 749.909 1876.7 757.358L1858.78 770.158C1843.96 780.744 1833.56 796.427 1829.59 814.203C1827.31 824.384 1822.91 833.967 1816.66 842.325L1800.3 864.232C1797.67 867.754 1796.25 872.032 1796.25 876.428V885.283C1796.25 894.801 1805.56 901.535 1814.6 898.555C1825.75 894.879 1836.19 905.763 1832.05 916.752L1831.36 918.57C1828.47 926.25 1832.33 934.823 1840 937.748L1859.49 945.183C1862.59 946.365 1864.63 949.337 1864.63 952.653C1864.63 961.125 1876.08 963.778 1879.81 956.169L1912.45 889.517C1918.9 876.343 1935.18 871.575 1948.68 877.309C1977.58 889.585 2011.91 896.002 2014.07 865.099C2016.72 827.294 2052.44 839.787 2055.76 877.538C2058.62 910.069 2057.18 946.901 2044.47 975.507Z",
    fill: "url(#paint1_linear_1794_3596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2044.47 975.507C2024.17 1021.16 1888.96 1056.17 1803.11 1072C1788.11 1074.77 1778.45 1089.67 1782.44 1104.39C1785 1113.85 1792.73 1121.01 1802.35 1122.85L1826.55 1127.47C1835.71 1129.22 1842.34 1137.23 1842.34 1146.57C1842.34 1155.55 1836.19 1163.37 1827.45 1165.47L1794.65 1173.36C1781.86 1176.43 1768.42 1175.38 1756.27 1170.35L1719.99 1155.32C1709.76 1151.08 1698.29 1150.95 1687.97 1154.96C1676.6 1159.37 1667.64 1168.39 1663.31 1179.79L1653.62 1205.32C1650.97 1212.31 1652.17 1220.17 1656.8 1226.04C1664.13 1235.33 1662.46 1248.82 1653.1 1256.05L1649.47 1258.85C1644.19 1262.93 1637.53 1264.8 1630.9 1264.08L1611.62 1261.98C1598.92 1260.6 1586.89 1267.94 1582.31 1279.87L1581.53 1281.9C1578.09 1290.87 1580.16 1301.02 1586.84 1307.93C1596.8 1318.23 1595.94 1334.82 1584.96 1344.04L1539.29 1382.35C1535 1385.95 1531.11 1390 1527.59 1394.37C1518.56 1405.57 1506.12 1420.18 1503.45 1420.18C1502.59 1420.18 1503.02 1423.34 1504.25 1428.41C1512.96 1464.29 1548.79 1486.15 1585.61 1483.42L1588.49 1483.21C1599.52 1482.39 1610.58 1484.21 1620.77 1488.52C1634.09 1494.14 1648.82 1495.49 1662.93 1492.38L1695.46 1485.2C1704.96 1483.11 1714.9 1484.27 1723.66 1488.5L1731.24 1492.15C1750.7 1501.54 1757.55 1525.85 1745.85 1544.02C1730.43 1567.96 1747.61 1599.47 1776.08 1599.47H1859.83C1880.9 1599.47 1895.18 1578.02 1887.05 1558.59C1883.18 1549.34 1884.27 1538.77 1889.94 1530.51L1898.56 1517.96C1902.26 1512.57 1905.01 1506.6 1906.7 1500.3L1924.23 1434.8C1928.67 1418.24 1937.28 1403.1 1949.25 1390.83L1969.62 1369.94C1983.39 1355.83 2001.15 1346.29 2020.52 1342.6C2048.83 1337.21 2073.23 1319.42 2087.02 1294.12L2106.89 1257.67C2117.64 1237.95 2134.73 1222.42 2155.38 1213.59L2165.92 1209.08C2185.74 1200.61 2208.15 1200.6 2227.98 1209.06C2232.61 1211.03 2237.04 1213.44 2241.2 1216.26L2256.35 1226.49C2266.97 1233.66 2278.86 1238.73 2291.38 1241.41L2320.07 1247.56C2335.23 1250.8 2351.01 1249.36 2365.33 1243.43L2432.26 1215.69C2437.04 1213.71 2442.5 1216.2 2444.14 1221.12C2445.36 1224.76 2448.77 1227.22 2452.61 1227.22H2457.84C2466.79 1227.22 2474.04 1234.47 2474.04 1243.41V1248.42C2474.04 1251.14 2474.56 1253.84 2475.58 1256.37L2493.58 1300.84C2498.41 1312.76 2500.88 1325.5 2500.88 1338.35V1355.27C2500.88 1376.05 2509.27 1395.95 2524.14 1410.47C2536.94 1422.97 2553.69 1430.63 2571.52 1432.14L2612.35 1435.59C2630.24 1437.11 2648.19 1433.73 2664.46 1426.13C2684.81 1416.64 2706.57 1406.96 2709.08 1407.52C2711.14 1407.98 2713.07 1399.68 2714.58 1389.93C2716.77 1375.83 2712.77 1361.58 2704.69 1349.82L2703.1 1347.5C2697.1 1338.76 2693.89 1328.41 2693.89 1317.8V1297.84C2693.89 1283.94 2703.86 1272.05 2717.55 1269.62C2727.67 1267.83 2737.97 1271.59 2744.55 1279.47L2775.02 1315.96C2779.88 1321.78 2782.54 1329.12 2782.54 1336.69V1339.18C2782.54 1345.05 2784.57 1350.74 2788.3 1355.28C2794.65 1363.03 2795.86 1373.78 2791.38 1382.74L2788.85 1387.8C2784.81 1395.88 2784.14 1405.25 2787 1413.83L2794.3 1435.7C2797.25 1444.55 2801.56 1452.88 2807.07 1460.39L2816.41 1473.12C2819.49 1477.33 2822.26 1481.75 2824.54 1486.44C2830.12 1497.86 2837.25 1513.85 2837.25 1519.45C2837.25 1528.06 2849.91 1538.19 2853.46 1542.74C2857 1547.3 2862.07 1558.95 2863.08 1563.51C2868.21 1586.57 2890.03 1602 2913.66 1602H2932.81C2975.99 1602 3011 1566.99 3011 1523.81V750.532C3011 717.623 2994.81 686.821 2967.7 668.161L2959.17 662.291C2952.55 657.73 2945.4 653.984 2937.87 651.137L2829.49 610.115C2814.94 604.607 2799.3 602.571 2783.82 604.168L2750.48 607.609C2736.22 609.081 2722.44 613.601 2710.09 620.863L2700.58 626.447C2681.74 637.52 2659.2 640.457 2638.15 634.583C2631.1 632.617 2623.82 631.652 2616.51 631.496C2600.1 631.145 2578.55 629.978 2574.34 627.062C2570.74 624.573 2553.25 626.19 2537.14 628.433C2524.34 630.216 2513.19 637.872 2506.33 648.835C2501.78 656.12 2499.37 664.537 2499.37 673.128V675.657C2499.37 689.957 2493.76 703.688 2483.75 713.902L2481.76 715.934C2477.31 720.473 2472.19 724.297 2466.57 727.269L2464.6 728.314C2460.1 730.698 2455.84 733.53 2451.91 736.766L2407.26 773.455C2401.19 778.444 2396.27 784.682 2392.82 791.744C2389.59 798.374 2385.05 804.281 2379.47 809.112L2372.72 814.959L2356.62 827.451C2348.01 834.127 2337.43 837.75 2326.54 837.75C2317.65 837.75 2308.92 835.333 2301.29 830.759L2291.79 825.059C2290.7 824.404 2289.67 823.662 2288.7 822.838L2279.2 814.765C2274.15 810.476 2273.76 802.82 2278.34 798.038C2280.39 795.897 2281.54 793.044 2281.54 790.078V778.112C2281.54 771.702 2280.05 765.38 2277.18 759.647L2273.84 752.966C2266.99 739.27 2264.63 723.766 2267.08 708.651L2268.13 702.228C2269.29 695.054 2271.72 688.142 2275.28 681.811C2284.66 665.166 2301.22 653.797 2320.12 651.018L2324.6 650.359L2341.1 645.983C2346.38 644.583 2350.78 640.934 2353.13 636.003C2357.11 627.667 2354.38 617.673 2346.71 612.519L2335.86 605.226C2332.44 602.921 2328.61 601.265 2324.59 600.339L2263.8 586.373C2254.07 584.137 2244.06 583.371 2234.1 584.102L2185.99 587.629C2177.45 588.254 2169.04 589.973 2160.94 592.742L2089.98 617.011C2081.29 619.984 2073.05 624.139 2065.5 629.361L2010.41 667.428C2008.8 668.538 2007.34 669.837 2006.04 671.297L1991.57 687.627C1989.78 689.638 1990.13 692.748 1992.31 694.321C1994.8 696.123 1994.82 699.834 1992.34 701.659L1957.16 727.552C1953.27 730.422 1948.83 732.484 1944.13 733.62L1911.36 741.528C1898.9 744.535 1887.13 749.909 1876.7 757.358L1858.78 770.158C1843.96 780.744 1833.56 796.427 1829.59 814.203C1827.31 824.384 1822.91 833.967 1816.66 842.325L1800.3 864.232C1797.67 867.754 1796.25 872.032 1796.25 876.428V885.283C1796.25 894.801 1805.56 901.535 1814.6 898.555C1825.75 894.879 1836.19 905.763 1832.05 916.752L1831.36 918.57C1828.47 926.25 1832.33 934.823 1840 937.748L1859.49 945.183C1862.59 946.365 1864.63 949.337 1864.63 952.653C1864.63 961.125 1876.08 963.778 1879.81 956.169L1912.45 889.517C1918.9 876.343 1935.18 871.575 1948.68 877.309C1977.58 889.585 2011.91 896.002 2014.07 865.099C2016.72 827.294 2052.44 839.787 2055.76 877.538C2058.62 910.069 2057.18 946.901 2044.47 975.507Z",
    stroke: "url(#paint2_linear_1794_3596)",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1794_3596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.39 1262.12L1053.03 1263.75C1058.45 1266.19 1064.62 1266.38 1070.19 1264.28C1081.11 1260.16 1093.37 1265.09 1098.41 1275.62L1099.98 1278.89C1103.75 1286.75 1103.4 1295.97 1099.04 1303.53L1077.37 1341.1C1071.64 1351.03 1069.58 1362.67 1071.54 1373.97L1073.35 1384.36C1075.6 1397.33 1084.73 1408.04 1097.17 1412.34C1102.96 1414.33 1108.15 1417.77 1112.25 1422.33L1118.37 1429.13C1126.5 1438.17 1137.69 1443.86 1149.78 1445.1L1183.86 1448.61C1198.21 1450.09 1211.19 1457.83 1219.32 1469.76L1260.49 1530.16C1266.03 1538.29 1269 1547.91 1269 1557.75V1621H661L655.978 1608.98C650.878 1596.77 650.933 1583.01 656.131 1570.84L668.775 1541.24C670.583 1537.01 672.977 1533.05 675.888 1529.49L703.715 1495.42C705.236 1493.56 706.618 1491.59 707.85 1489.53L721.245 1467.07C730.085 1452.25 746.07 1443.17 763.328 1443.17H797.5C806.5 1443.17 841 1432.61 849.5 1429.83C852.893 1428.72 855.598 1424.43 857.601 1419.51C861.213 1410.64 864.952 1401.62 871.43 1394.56L874.102 1391.65C882.397 1382.61 887 1370.79 887 1358.52V1352.59C887 1344.92 888.805 1337.34 892.269 1330.49L907.266 1300.82C910.387 1294.65 914.779 1289.2 920.154 1284.85L932.588 1274.78C938.45 1270.03 945.33 1266.7 952.69 1265.04L979.2 1259.09C985.168 1257.75 991.424 1258.76 996.661 1261.92C1002.59 1265.5 1009.78 1266.31 1016.36 1264.14L1026.14 1260.91C1033.77 1258.4 1042.06 1258.83 1049.39 1262.12Z",
    fill: "url(#paint3_linear_1794_3596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.39 1262.12L1053.03 1263.75C1058.45 1266.19 1064.62 1266.38 1070.19 1264.28C1081.11 1260.16 1093.37 1265.09 1098.41 1275.62L1099.98 1278.89C1103.75 1286.75 1103.4 1295.97 1099.04 1303.53L1077.37 1341.1C1071.64 1351.03 1069.58 1362.67 1071.54 1373.97L1073.35 1384.36C1075.6 1397.33 1084.73 1408.04 1097.17 1412.34C1102.96 1414.33 1108.15 1417.77 1112.25 1422.33L1118.37 1429.13C1126.5 1438.17 1137.69 1443.86 1149.78 1445.1L1183.86 1448.61C1198.21 1450.09 1211.19 1457.83 1219.32 1469.76L1260.49 1530.16C1266.03 1538.29 1269 1547.91 1269 1557.75V1621H661L655.978 1608.98C650.878 1596.77 650.933 1583.01 656.131 1570.84L668.775 1541.24C670.583 1537.01 672.977 1533.05 675.888 1529.49L703.715 1495.42C705.236 1493.56 706.618 1491.59 707.85 1489.53L721.245 1467.07C730.085 1452.25 746.07 1443.17 763.328 1443.17H797.5C806.5 1443.17 841 1432.61 849.5 1429.83C852.893 1428.72 855.598 1424.43 857.601 1419.51C861.213 1410.64 864.952 1401.62 871.43 1394.56L874.102 1391.65C882.397 1382.61 887 1370.79 887 1358.52V1352.59C887 1344.92 888.805 1337.34 892.269 1330.49L907.266 1300.82C910.387 1294.65 914.779 1289.2 920.154 1284.85L932.588 1274.78C938.45 1270.03 945.33 1266.7 952.69 1265.04L979.2 1259.09C985.168 1257.75 991.424 1258.76 996.661 1261.92C1002.59 1265.5 1009.78 1266.31 1016.36 1264.14L1026.14 1260.91C1033.77 1258.4 1042.06 1258.83 1049.39 1262.12Z",
    stroke: "url(#paint4_linear_1794_3596)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1794_3596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1332.62 781.087C1331.72 784.724 1330.87 788.546 1330.27 791.901C1329.24 797.646 1331.9 802.885 1336.21 806.822L1343.21 813.217C1357.02 825.84 1376.06 832.017 1394.07 826.937C1398.29 825.748 1401.75 824.537 1403.58 823.417C1405.73 822.098 1410.6 818.829 1416.49 814.811C1435.96 801.523 1448.77 780.53 1452.08 757.189L1454.75 738.276C1455.83 730.667 1459.17 723.56 1464.35 717.877L1468.61 713.191C1472.83 708.556 1475 702.414 1474.63 696.157C1473.98 685.258 1465.83 676.28 1455.04 674.579L1425.16 669.864C1416.05 668.426 1406.74 669.078 1397.92 671.769L1381.83 676.677C1365.58 681.636 1352.31 693.459 1345.52 709.034L1345.15 709.899C1344.02 712.497 1342.65 714.988 1341.08 717.344L1322.51 745.101C1318.08 751.72 1319.88 760.679 1326.52 765.069C1331.76 768.531 1334.12 774.988 1332.62 781.087Z",
    fill: "url(#paint5_linear_1794_3596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.28 484.347C1348.83 482.524 1427.07 466.793 1469.34 458.415C1472.02 457.885 1474.78 458.046 1477.38 458.881C1488.46 462.449 1492.18 476.246 1484.28 484.809C1450.01 521.988 1400.22 573.64 1388.84 576.356C1378.63 578.793 1356.44 591.9 1339.61 602.632C1331.03 608.103 1320.2 608.814 1311.13 604.209C1303.16 600.167 1293.77 600.171 1285.78 604.174C1257.23 618.492 1214.59 639.283 1204.42 641.956C1194.08 644.673 1140.02 670.536 1104.46 687.921C1095.15 692.473 1085.04 695.161 1074.69 695.778L1062.45 696.508C1055.27 696.937 1048.11 695.249 1041.88 691.654C1033.39 686.756 1023.31 685.453 1013.84 687.996C980.251 697.015 930.902 709.867 922.993 710.339L901.487 711.622C892.414 712.163 884.622 705.247 884.08 696.175C883.941 693.843 883.307 691.568 882.221 689.5L882.096 689.262C878.454 682.332 879.797 673.832 885.397 668.361L910.453 643.887C915.814 638.649 922.023 634.395 928.842 631.282C969.93 612.523 1037.53 581.328 1044.26 576.879C1053.42 570.823 1186.57 535.831 1197.93 533.15C1209.29 530.468 1338.41 486.7 1344.28 484.347Z",
    fill: "url(#paint6_linear_1794_3596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.62 781.087C1331.72 784.724 1330.87 788.546 1330.27 791.901C1329.24 797.646 1331.9 802.885 1336.21 806.822L1343.21 813.217C1357.02 825.84 1376.06 832.017 1394.07 826.937C1398.29 825.748 1401.75 824.537 1403.58 823.417C1405.73 822.098 1410.6 818.829 1416.49 814.811C1435.96 801.523 1448.77 780.53 1452.08 757.189L1454.75 738.276C1455.83 730.667 1459.17 723.56 1464.35 717.877L1468.61 713.191C1472.83 708.556 1475 702.414 1474.63 696.157C1473.98 685.258 1465.83 676.28 1455.04 674.579L1425.16 669.864C1416.05 668.426 1406.74 669.078 1397.92 671.769L1381.83 676.677C1365.58 681.636 1352.31 693.459 1345.52 709.034L1345.15 709.899C1344.02 712.497 1342.65 714.988 1341.08 717.344L1322.51 745.101C1318.08 751.72 1319.88 760.679 1326.52 765.069C1331.76 768.531 1334.12 774.988 1332.62 781.087Z",
    stroke: "url(#paint7_linear_1794_3596)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.28 484.347C1348.83 482.524 1427.07 466.793 1469.34 458.415C1472.02 457.885 1474.78 458.046 1477.38 458.881C1488.46 462.449 1492.18 476.246 1484.28 484.809C1450.01 521.988 1400.22 573.64 1388.84 576.356C1378.63 578.793 1356.44 591.9 1339.61 602.632C1331.03 608.103 1320.2 608.814 1311.13 604.209C1303.16 600.167 1293.77 600.171 1285.78 604.174C1257.23 618.492 1214.59 639.283 1204.42 641.956C1194.08 644.673 1140.02 670.536 1104.46 687.921C1095.15 692.473 1085.04 695.161 1074.69 695.778L1062.45 696.508C1055.27 696.937 1048.11 695.249 1041.88 691.654C1033.39 686.756 1023.31 685.453 1013.84 687.996C980.251 697.015 930.902 709.867 922.993 710.339L901.487 711.622C892.414 712.163 884.622 705.247 884.08 696.175C883.941 693.843 883.307 691.568 882.221 689.5L882.096 689.262C878.454 682.332 879.797 673.832 885.397 668.361L910.453 643.887C915.814 638.649 922.023 634.395 928.842 631.282C969.93 612.523 1037.53 581.328 1044.26 576.879C1053.42 570.823 1186.57 535.831 1197.93 533.15C1209.29 530.468 1338.41 486.7 1344.28 484.347Z",
    stroke: "url(#paint8_linear_1794_3596)",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1794_3596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1426.54 1053.7L1442.04 1035.9C1444.01 1033.64 1446.23 1031.62 1448.66 1029.88L1450.53 1028.54C1463.88 1018.96 1480.66 1015.46 1496.73 1018.91L1507.84 1021.29C1516.13 1023.06 1523.77 1027.05 1529.96 1032.84C1542.86 1044.89 1548.03 1063.25 1542.22 1079.93C1538.14 1091.64 1533.82 1102.46 1531 1105.5C1528.05 1108.67 1519.51 1115.31 1510.72 1121.84C1498.97 1130.55 1484.65 1135 1470.02 1135H1446.84C1439.07 1135 1431.76 1131.34 1427.09 1125.12C1421.51 1117.69 1420.59 1107.74 1424.7 1099.4L1430.09 1088.46C1432.72 1083.12 1431.61 1076.69 1427.33 1072.55C1422.1 1067.48 1421.75 1059.19 1426.54 1053.7Z",
    fill: "#07241E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.54 1053.7L1442.04 1035.9C1444.01 1033.64 1446.23 1031.62 1448.66 1029.88L1450.53 1028.54C1463.88 1018.96 1480.66 1015.46 1496.73 1018.91L1507.84 1021.29C1516.13 1023.06 1523.77 1027.05 1529.96 1032.84C1542.86 1044.89 1548.03 1063.25 1542.22 1079.93C1538.14 1091.64 1533.82 1102.46 1531 1105.5C1528.05 1108.67 1519.51 1115.31 1510.72 1121.84C1498.97 1130.55 1484.65 1135 1470.02 1135H1446.84C1439.07 1135 1431.76 1131.34 1427.09 1125.12C1421.51 1117.69 1420.59 1107.74 1424.7 1099.4L1430.09 1088.46C1432.72 1083.12 1431.61 1076.69 1427.33 1072.55C1422.1 1067.48 1421.75 1059.19 1426.54 1053.7Z",
    stroke: "url(#paint9_linear_1794_3596)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2218.55 1586.58C2209.44 1591.43 2201.19 1594.49 2195.11 1596.33C2198.12 1598.87 2200.67 1601.5 2202.8 1603.43C2209.75 1605.58 2221.7 1607.64 2245.98 1606.42C2253.03 1606.07 2265.14 1606.71 2290.06 1604.45C2305.31 1603.07 2325.43 1600.38 2340.08 1599.04C2354.72 1597.69 2363.62 1597.85 2368.79 1597.57C2375.39 1597.22 2394.24 1597.64 2420.33 1596.88C2430.97 1596.57 2436.26 1597.55 2437.43 1594.31C2439.68 1588.06 2439.75 1580.07 2438.49 1572.92C2437.17 1565.47 2431.87 1558.35 2427.22 1547.16C2424.12 1539.69 2420.21 1525.42 2426.53 1508.67C2430.9 1497.07 2435.47 1488.54 2431.34 1480.94C2427.57 1474.02 2419.09 1463.22 2415.72 1452.81C2410.24 1435.87 2409.87 1420.31 2412.09 1412.43C2413.94 1405.83 2421.46 1395.75 2416.77 1383.88C2413.54 1375.7 2407.65 1362.03 2398.77 1359.97L2398.37 1359.88C2392.95 1358.62 2388.13 1357.5 2385.09 1358.23C2379.35 1359.62 2371.14 1361.84 2363.63 1370.65C2358.17 1377.05 2354.84 1387.75 2348.1 1398.25C2340.18 1410.58 2331.45 1413.91 2325.39 1418.65C2318.76 1423.83 2314.22 1432.69 2303.78 1440.27C2294.45 1447.04 2275.39 1458.83 2262.93 1462.67C2247.67 1467.37 2229.78 1473.76 2222.29 1485.31C2216.94 1493.55 2214.25 1506.48 2215.42 1515.2C2216.38 1522.39 2217.89 1532.19 2221.63 1544.63C2223.98 1552.46 2230.62 1558.9 2232.09 1566.26C2232.82 1569.94 2232.92 1574 2230.3 1576.91C2227.28 1580.28 2223.92 1583.72 2218.55 1586.58Z",
    fill: "#171140"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2041.5,
    cy: 1298.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2037.5,
    cy: 1326.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2012.5,
    cy: 1345.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2012.5,
    cy: 1302.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1984.5,
    cy: 1231.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2006.5,
    cy: 1205.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2162.5,
    cy: 1215.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2188,
    cy: 1186,
    r: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2188,
    cy: 1206.5,
    rx: 10,
    ry: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 2204.5,
    cy: 1197,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2235.5,
    cy: 1188,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2260.5,
    cy: 1202.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2316.5,
    cy: 1243.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2325.5,
    cy: 1224.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2362.5,
    cy: 1243.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2406.5,
    cy: 1476.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2797,
    cy: 1387.5,
    rx: 10,
    ry: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2818.5,
    cy: 1372.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2840.5,
    cy: 1348.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2837.5,
    cy: 1403.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.43,
    cx: 2802.5,
    cy: 1433,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2772.5,
    cy: 1302.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2346.5,
    cy: 1476.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2372.5,
    cy: 1229.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2371.5,
    cy: 1202.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2391.5,
    cy: 1196,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2417,
    cy: 1196,
    r: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2410.5,
    cy: 1210.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2400.5,
    cy: 1224.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2370.5,
    cy: 1481.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2380.5,
    cy: 1221.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2378.5,
    cy: 1508.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2430,
    cy: 1200,
    r: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.43,
    cx: 2448.5,
    cy: 1188,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2485.5,
    cy: 1166.5,
    r: 12.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2507.5,
    cy: 1192,
    rx: 12.5,
    ry: 13,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2470.5,
    cy: 1207.5,
    r: 12.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2368.5,
    cy: 1444,
    rx: 12.5,
    ry: 13,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2790,
    cy: 1339.5,
    rx: 13,
    ry: 12.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1990.5,
    cy: 1332.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1956.5,
    cy: 1361.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 1929,
    cy: 1404.5,
    rx: 10,
    ry: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1901.5,
    cy: 1418.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1923.5,
    cy: 1433,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1911.5,
    cy: 1457.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1877.5,
    cy: 1452.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1904.5,
    cy: 1476.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1868.5,
    cy: 1480.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1891.5,
    cy: 1506.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1772.5,
    cy: 1530.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1743.5,
    cy: 1584.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1716.5,
    cy: 1476.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1641.5,
    cy: 1476.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1772.5,
    cy: 1571.5,
    r: 12.5,
    fill: "#AD9C4B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1794_3596)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2003,
    cy: 835,
    r: 16,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2129,
    cy: 897,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2186,
    cy: 917,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2181,
    cy: 840,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2096,
    cy: 947,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1730,
    cy: 1294,
    r: 14,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.5,
    cy: 1275.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1789.5,
    cy: 1322.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1762.5,
    cy: 1344.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1701.5,
    cy: 1352.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1836.5,
    cy: 1312.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2010.5,
    cy: 1216.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1732,
    cy: 1210,
    r: 9,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2030,
    cy: 1187,
    r: 9,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2026.5,
    cy: 1118.5,
    r: 7.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1510.5,
    cy: 1099.5,
    r: 7.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1407.5,
    cy: 793.5,
    r: 7.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1476.5,
    cy: 1092.5,
    r: 7.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1378.5,
    cy: 808.5,
    r: 7.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1480.5,
    cy: 1118.5,
    r: 7.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1493.5,
    cy: 1110.5,
    r: 9.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1087.5,
    cy: 1421.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1094.5,
    cy: 1462.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 968.5,
    cy: 1544.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 927.5,
    cy: 1534.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 934.5,
    cy: 1568.5,
    r: 11.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.5,
    cy: 1451.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1121.5,
    cy: 1502.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1451.5,
    cy: 1115.5,
    r: 8.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1356.5,
    cy: 794.5,
    r: 8.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2115,
    cy: 988,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2129,
    cy: 943,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2151,
    cy: 917,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2104,
    cy: 911,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2153,
    cy: 975,
    r: 11,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2135.5,
    cy: 872.5,
    r: 9.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2153.5,
    cy: 883.5,
    r: 6.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2112.5,
    cy: 862.5,
    r: 8.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2047.5,
    cy: 983.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2022.5,
    cy: 996.5,
    r: 10.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1960.5,
    cy: 736.5,
    r: 9.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2286.5,
    cy: 796.5,
    r: 9.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2455.5,
    cy: 927.5,
    r: 9.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2516.5,
    cy: 951.5,
    r: 9.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2317,
    cy: 826,
    r: 8,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2478,
    cy: 967,
    r: 8,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2499,
    cy: 929,
    r: 8,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2499,
    cy: 900,
    r: 12,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2873.5,
    cy: 920.5,
    r: 6.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2893,
    cy: 927,
    r: 9,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2908.5,
    cy: 909.5,
    r: 6.5,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2879,
    cy: 897,
    r: 9,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2861,
    cy: 1019,
    r: 6,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2569,
    cy: 903,
    r: 8,
    fill: "#F5CF63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2572,
    cy: 877,
    r: 11,
    fill: "#F5CF63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1794_3596",
    x: -296,
    y: 371,
    width: 4474,
    height: 3868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1794_3596"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1794_3596",
    x: -259,
    y: 0,
    width: 4240,
    height: 3467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1794_3596"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1794_3596",
    x: 194,
    y: 122,
    width: 4246,
    height: 3564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1794_3596"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1794_3596",
    x: 1487.1,
    y: 567.934,
    width: 1539.8,
    height: 1049.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7,
    result: "effect1_foregroundBlur_1794_3596"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1794_3596",
    x: 638.292,
    y: 1244.61,
    width: 644.608,
    height: 390.288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7,
    result: "effect1_foregroundBlur_1794_3596"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1794_3596",
    x: 864.663,
    y: 442.709,
    width: 639.232,
    height: 401.408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7,
    result: "effect1_foregroundBlur_1794_3596"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1794_3596",
    x: 1407.76,
    y: 1003.21,
    width: 151.235,
    height: 146.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7,
    result: "effect1_foregroundBlur_1794_3596"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1794_3596",
    x: 907,
    y: 717,
    width: 2018,
    height: 873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1794_3596"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1794_3596",
    x1: 1251,
    y1: 609,
    x2: 1728.5,
    y2: 1979.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0384615,
    stopColor: "#647BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173077,
    stopColor: "#647BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1794_3596",
    x1: 2257,
    y1: 583,
    x2: 2539.5,
    y2: 1457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192308,
    stopColor: "#07271B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "#171140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1794_3596",
    x1: 1993.5,
    y1: 611,
    x2: 2089,
    y2: 817.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1794_3596",
    x1: 982,
    y1: 1348,
    x2: 910,
    y2: 1601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07271B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694025,
    stopColor: "#171141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1794_3596",
    x1: 1063.5,
    y1: 1291.5,
    x2: 924,
    y2: 1645.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1794_3596",
    x1: 1182.69,
    y1: 474.954,
    x2: 1398,
    y2: 862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A381F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1794_3596",
    x1: 1182.69,
    y1: 474.954,
    x2: 1398,
    y2: 862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A381F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1794_3596",
    x1: 1332.5,
    y1: 491.5,
    x2: 1204.63,
    y2: 842.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1794_3596",
    x1: 1332.5,
    y1: 491.5,
    x2: 1204.63,
    y2: 842.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1794_3596",
    x1: 1468.5,
    y1: 1013,
    x2: 1484.5,
    y2: 1135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth2);
export default __webpack_public_path__ + "static/media/earth2.8ac698d29c7c8a8f1c3efdf57979c8ad.svg";
export { ForwardRef as ReactComponent };